import { TaskQueue } from './TaskQueue';

export * from './const';
export const taskQueue = new TaskQueue(1);
